import { useCallback, useEffect, useState } from "react";
import { api, extractList, getApiError } from "@/api/client";

const REFRESH_MS = 30_000;
export const usePresenceData = (windowMin, creatorsOnly) => {
  const [state, setState] = useState({ items: [], watchlist: [], onlineCount: 0, liveCount: 0, loading: true, error: "", updatedAt: null });
  const load = useCallback(async ({ silent = false } = {}) => {
    if (!silent) setState((current) => ({ ...current, loading: true, error: "" }));
    try {
      const [presenceResponse, watchlistResponse] = await Promise.all([
        api.get("/admin/presence", { params: { window_min: windowMin, creators_only: creatorsOnly, limit: 1000 } }),
        api.get("/admin/watchlist"),
      ]);
      const presence = presenceResponse.data || {};
      setState({ items: extractList(presence, ["items"]), watchlist: extractList(watchlistResponse.data, ["watchlist"]), onlineCount: Number(presence.online_count || 0), liveCount: Number(presence.live_count || 0), loading: false, error: "", updatedAt: new Date() });
    } catch (error) { setState((current) => ({ ...current, loading: false, error: getApiError(error) })); }
  }, [windowMin, creatorsOnly]);
  useEffect(() => { load(); const interval = window.setInterval(() => load({ silent: true }), REFRESH_MS); return () => window.clearInterval(interval); }, [load]);
  return { ...state, reload: load };
};